module.exports = __webpack_public_path__ + "static/img/主视觉KV设计-3D主视觉.6d49a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10001/主视觉KV设计-3D主视觉.png
// module id = y8CP
// module chunks = 1